import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table/main';
import StatusesFilters from './components/quick-filters/main';
import { selectors as rootSelectors } from '../root';
import Search from '../shared/search/main';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content defined-referers-list">
			<div className="container__content-title">
				<div className="container__content-title-position">
					<h1 className="title">{props.intl('List of referers')}</h1>
				</div>
			</div>
			<div className="container__content-body">

				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---search">
						<div className="ui-control-bar__item-position">
							<Search
								form="definedReferersSearchForm"
								autoFocus={true}
								action={props.search}
								{...props}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---filter">
						<div className="ui-control-bar__item-position">
							<StatusesFilters {...props} />
						</div>
					</div>
				</div>

				<Table {...props} />
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		refererTypeOptions: selectors.getRefererTypeOptions(state),
		statusesFilters: selectors.getFilters(state),
		pagination: selectors.getPagination(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/defined-referers/main.js